<template>
    <node-view-wrapper as="span" class="copilot-attr-wrapper">
        <a-tooltip :title="node.attrs.label">
            <span class="copilot-attr-chip" contenteditable="false">
                <i class="material-icons">data_object</i>
                <span v-text="chipLabel"></span>
            </span>
        </a-tooltip>
    </node-view-wrapper>
</template>

<script>
import { nodeViewProps, NodeViewWrapper } from "@tiptap/vue-2";

export default {
    name: "CoPilotAttrNode",
    props: nodeViewProps,
    components: { NodeViewWrapper },
    computed: {
        chipLabel: function () {
            return this.node.attrs.label || this.node.attrs.name;
        },
    },
};
</script>

<style lang="scss">
.copilot-attr-wrapper {
    display: inline;
}
.copilot-attr-chip {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    background: #ede9fe;
    border: 1px solid #c4b5fd;
    color: #6d28d9;
    border-radius: 4px;
    padding: 1px 6px;
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;
    cursor: default;
    user-select: none;
    vertical-align: baseline;
    white-space: nowrap;

    .material-icons {
        font-size: 13px;
    }
}
</style>
